module.exports = __webpack_public_path__ + "img/109.96a75873.svg";